import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

// ── Icon constants ────────────────────────────────────────────────────────────

const DASHBOARD_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1.5"/>
    <rect x="14" y="3" width="7" height="7" rx="1.5"/>
    <rect x="3" y="14" width="7" height="7" rx="1.5"/>
    <rect x="14" y="14" width="7" height="7" rx="1.5"/>
  </svg>
)

const USERS_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="8" r="3.2"/>
    <path d="M3.5 19a5.5 5.5 0 0 1 11 0M16 6.5a3 3 0 0 1 0 5M18 19a5 5 0 0 0-3-4.6"/>
  </svg>
)

const GLOBE_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/>
    <path d="M3.6 9h16.8M3.6 15h16.8M12 3c-2.5 3-4 5.8-4 9s1.5 6 4 9M12 3c2.5 3 4 5.8 4 9s-1.5 6-4 9"/>
  </svg>
)

const EDIT_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4v16h16v-7"/>
    <path d="m14.5 5.5 4 4L11 17l-4 1 1-4 7.5-8.5Z"/>
  </svg>
)

const IMAGE_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="3"/>
    <circle cx="8.5" cy="8.5" r="1.5"/>
    <path d="m21 15-5-5L5 21"/>
  </svg>
)

const INBOX_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/>
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11Z"/>
  </svg>
)

const CHART_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19V5M4 19h16M8 16v-4M12 16V8M16 16v-6"/>
  </svg>
)

const LINK_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
)

const CARD_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2"/>
    <path d="M2 10h20"/>
  </svg>
)

const SETTINGS_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/>
  </svg>
)

const MESSAGE_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
)

const HELP_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/>
    <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01"/>
  </svg>
)

const LOGOUT_ICON = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
)

const COLLAPSE_ICON = (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m11 17-5-5 5-5M18 17l-5-5 5-5"/>
  </svg>
)

// ── Nav item definitions ──────────────────────────────────────────────────────

const ADMIN_ITEMS = [
  { label: 'Dashboard',     route: '/admin',           icon: DASHBOARD_ICON, exact: true },
  { label: 'Clients',       route: '/admin/clients',   icon: USERS_ICON },
  { label: 'Sites',         route: '/admin/sites',     icon: GLOBE_ICON },
  { label: 'Visual Editor', route: '/admin/neweditor', icon: EDIT_ICON, accent: true },
  { label: 'Media',         route: '/admin/media',     icon: IMAGE_ICON },
  { label: 'Requests',      route: '/admin/requests',  icon: INBOX_ICON },
  { label: 'Analytics',     route: '/admin/analytics', icon: CHART_ICON },
  { label: 'Domains',       route: '/admin/domains',   icon: LINK_ICON },
  { label: 'Billing',       route: '/admin/billing',   icon: CARD_ICON },
  { label: 'Settings',      route: '/admin/settings',  icon: SETTINGS_ICON },
]

const CLIENT_ITEMS = [
  { label: 'Home',        route: '/client',           icon: DASHBOARD_ICON, exact: true },
  { label: 'Edit my site', route: '/client/editor',   icon: EDIT_ICON, accent: true },
  { label: 'Requests',    route: '/client/requests',  icon: MESSAGE_ICON },
  { label: 'Analytics',   route: '/client/analytics', icon: CHART_ICON },
  { label: 'Domain',      route: '/client/domain',    icon: LINK_ICON },
  { label: 'Billing',     route: '/client/billing',   icon: CARD_ICON },
  { label: 'Help',        route: '/client/support',   icon: HELP_ICON },
]

// ── Component ─────────────────────────────────────────────────────────────────

export default function Sidebar({ collapsed, onCollapse, mobileOpen }) {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, logout } = useAuth()
  const isAdmin = user?.role === 'admin'

  const items = isAdmin ? ADMIN_ITEMS : CLIENT_ITEMS

  function isActive(item) {
    if (item.exact || item.route === '/admin' || item.route === '/client') {
      return location.pathname === item.route || location.pathname === item.route + '/'
    }
    return location.pathname.startsWith(item.route)
  }

  function getInitials(name) {
    if (!name) return 'U'
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
  }

  return (
    <aside className={`sidebar${mobileOpen ? ' mobile-open' : ''}`} style={{ width: collapsed ? 68 : 248 }}>
      <div className="sidebar-inner">

        {/* Logo / workspace */}
        <div className="ws-switcher">
          <div className="ws-logo">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="none">
              <defs>
                <linearGradient id="wn-grad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#A78BFA"/>
                  <stop offset="100%" stopColor="#5B7CFF"/>
                </linearGradient>
              </defs>
              <rect width="24" height="24" rx="7" fill="url(#wn-grad)"/>
              <path d="M8 8.5c1.6-2 6.4-2 8 0M8 12c1.6-2 6.4-2 8 0M8 15.5c1.6-2 6.4-2 8 0" stroke="white" strokeWidth="1.6" strokeLinecap="round"/>
            </svg>
          </div>
          {!collapsed && (
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="ws-name">WebNest</div>
              <div className="ws-meta">{isAdmin ? 'Admin workspace' : 'Client portal'}</div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {!collapsed && (
            <div className="nav-section-label">{isAdmin ? 'Workspace' : 'Your site'}</div>
          )}
          {items.map((item) => (
            <button
              key={item.route}
              className={`nav-item${isActive(item) ? ' active' : ''}${item.accent ? ' accent' : ''}`}
              onClick={() => navigate(item.route)}
              title={collapsed ? item.label : undefined}
              style={{ justifyContent: collapsed ? 'center' : undefined }}
            >
              <span className="nav-icon">{item.icon}</span>
              {!collapsed && <span style={{ flex: 1 }}>{item.label}</span>}
            </button>
          ))}
        </nav>

        <div style={{ flex: 1 }} />

        {/* User + logout at bottom */}
        {!collapsed && (
          <div style={{ padding: '8px 4px', borderTop: '1px solid var(--border)', marginTop: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 6px', borderRadius: 10 }}>
              <div className="ds-avatar ds-avatar-1" style={{ width: 32, height: 32, fontSize: 12 }}>
                {getInitials(user?.name)}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="user-name">{user?.name || 'User'}</div>
                <div className="user-sub">{user?.email}</div>
              </div>
              <button
                className="ds-btn ds-btn-ghost ds-btn-icon"
                onClick={logout}
                title="Sign out"
                style={{ flexShrink: 0 }}
              >
                {LOGOUT_ICON}
              </button>
            </div>
          </div>
        )}
        {collapsed && (
          <button
            className="ds-btn ds-btn-ghost ds-btn-icon"
            onClick={logout}
            title="Sign out"
            style={{ margin: '8px auto' }}
          >
            {LOGOUT_ICON}
          </button>
        )}

        {/* Collapse button */}
        <button
          className="collapse-btn"
          onClick={onCollapse}
          title={collapsed ? 'Expand' : 'Collapse'}
          style={{ transform: collapsed ? 'rotate(180deg)' : undefined }}
        >
          {COLLAPSE_ICON}
        </button>

      </div>
    </aside>
  )
}
